import React from 'react';

const CopyText = (props: object) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.125 1.5H4.125C4.02554 1.5 3.93016 1.53951 3.85984 1.60984C3.78951 1.68016 3.75 1.77554 3.75 1.875V3.75H1.875C1.77554 3.75 1.68016 3.78951 1.60984 3.85984C1.53951 3.93016 1.5 4.02554 1.5 4.125V10.125C1.5 10.2245 1.53951 10.3198 1.60984 10.3902C1.68016 10.4605 1.77554 10.5 1.875 10.5H7.875C7.97446 10.5 8.06984 10.4605 8.14017 10.3902C8.21049 10.3198 8.25 10.2245 8.25 10.125V8.25H10.125C10.2245 8.25 10.3198 8.21049 10.3902 8.14017C10.4605 8.06984 10.5 7.97446 10.5 7.875V1.875C10.5 1.77554 10.4605 1.68016 10.3902 1.60984C10.3198 1.53951 10.2245 1.5 10.125 1.5ZM7.5 9.75H2.25V4.5H7.5V9.75ZM9.75 7.5H8.25V4.125C8.25 4.02554 8.21049 3.93016 8.14017 3.85984C8.06984 3.78951 7.97446 3.75 7.875 3.75H4.5V2.25H9.75V7.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CopyText;
